import React, { useCallback } from 'react';

import { Box, Button, Typography } from '@mui/material';
import AutocompleteCDS from '@sharedCR/coreDesignSystem/form/AutocompleteCDS';
import PropTypes from 'prop-types';

import {
  BACK_TO_CHANGE_LABEL,
  COMPARE_WITH_CURRENT_LABEL,
  VERSION_OPTION_KEY,
  VERSION_PICKER_LABEL,
  VERSION_PICKER_NAME,
  VERSION_PICKER_WIDTH,
} from '../../FormChangeHistory.constants';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import { getVersionOptionLabel } from '../../FormChangeHistory.utils';
import VersionOption from '../VersionOption';

import { compareHeaderStyles, compareHeaderTitleStyles } from './VersionCompareHeader.styles';

/** The compare's title, the version it compares (any listed change), and the way back to it. */
const VersionCompareHeader = ({ options, onSelectVersion, onBack, auditId = null }) => {
  const selectedOption = options.find(option => option.auditId === auditId) ?? null;

  const onChange = useCallback(
    (event, option) => onSelectVersion(option.auditId),
    [onSelectVersion],
  );

  return (
    <Box sx={compareHeaderStyles}>
      <Typography component="h5" sx={compareHeaderTitleStyles} variant="bold20">
        {COMPARE_WITH_CURRENT_LABEL}
      </Typography>
      <AutocompleteCDS
        disableClearable
        OptionContent={VersionOption}
        dataTestId={FormChangeHistoryTestIds.VERSION_PICKER}
        dataTestIdInput={FormChangeHistoryTestIds.VERSION_PICKER_INPUT}
        dataTestIdOption={FormChangeHistoryTestIds.VERSION_OPTION}
        getOptionLabel={getVersionOptionLabel}
        label={VERSION_PICKER_LABEL}
        name={VERSION_PICKER_NAME}
        optionKey={VERSION_OPTION_KEY}
        options={options}
        value={selectedOption}
        width={VERSION_PICKER_WIDTH}
        withSortedOptions={false}
        onChange={onChange}
      />
      <Button
        data-testid={FormChangeHistoryTestIds.BACK_TO_CHANGE_BUTTON}
        variant="line"
        onClick={onBack}
      >
        {BACK_TO_CHANGE_LABEL}
      </Button>
    </Box>
  );
};

VersionCompareHeader.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({ auditId: PropTypes.string.isRequired })).isRequired,
  onSelectVersion: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  auditId: PropTypes.string,
};

export default VersionCompareHeader;
